import { render, staticRenderFns } from "./AdvertsBanner.vue?vue&type=template&id=6a209bac&"
import script from "./AdvertsBanner.vue?vue&type=script&lang=ts&"
export * from "./AdvertsBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertsBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports